<template>
  <div>
    <t-form labelWidth="90px">
      <!-- v-if="cptDataForm.dataSource == '4'" -->
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
      <e-collapse title="label" :expand="true">
        <t-form-item label="总数label">
          <t-input v-model="attribute.label.totalLabel" size="small" />
        </t-form-item>
        <t-form-item label="进度label">
          <t-input v-model="attribute.label.valueLabel" size="small" />
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="attribute.label.color"
            size="small"
          />
        </t-form-item>
        <t-form-item label="文字大小">
          <t-input-number
            :min="12"
            :max="200"
            v-model="attribute.label.fontSize"
            size="small"
          />
        </t-form-item>
      </e-collapse>
      <e-collapse title="数值" :expand="true">
        <t-form-item label="字体">
          <t-select v-model="attribute.value.fontFamily" size="small">
            <t-option
              v-for="item in textFamilyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </t-select>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="attribute.value.color"
            size="small"
          />
        </t-form-item>
        <t-form-item label="文字大小">
          <t-input-number
            :min="12"
            :max="200"
            v-model="attribute.value.fontSize"
            size="small"
          />
        </t-form-item>
      </e-collapse>
      <e-collapse title="进度" :expand="false">
        <t-form-item label="颜色">
          <t-color-picker
            :colorModes="['monochrome']"
            format="HEX"
            v-model="attribute.progress.color[0]"
            size="small"
          />
          <t-color-picker
            :colorModes="['monochrome']"
            format="HEX"
            v-model="attribute.progress.color[1]"
            size="small"
          />
        </t-form-item>
        <t-form-item label="背景">
          <t-color-picker
            :colorModes="['monochrome']"
            format="HEX"
            v-model="attribute.progress.bgColor"
            size="small"
          />
        </t-form-item>
        <t-form-item label="大小">
          <t-input-number v-model="attribute.progress.size" size="small" />
        </t-form-item>
        <t-form-item label="百分比">
          <t-radio-group v-model="attribute.value.position" size="small">
            <t-radio-button value="icon">图标中心</t-radio-button>
            <t-radio-button value="progress">进度条末尾</t-radio-button>
          </t-radio-group>
        </t-form-item>
      </e-collapse>
      <e-collapse title="图标" :expand="false">
        <t-form-item label="显示图标">
          <t-switch
            v-model="attribute.icon.show"
            size="small"
            :label="['开', '关']"
          />
        </t-form-item>
        <template v-if="attribute.icon.show">
          <t-form-item label="图库选择">
            <div @click="showGallery" style="width: 168px; height: 160px">
              <t-image
                style="width: 100%; height: 100%; background: none"
                :src="fileUrl + attribute.icon.url"
                fit="fill"
              />
            </div>
          </t-form-item>
          <t-form-item label="自动旋转">
            <t-radio-group v-model="attribute.icon.autoRotate" size="small">
              <t-radio :value="true">开启</t-radio>
              <t-radio :value="false">关闭</t-radio>
            </t-radio-group>
          </t-form-item>
        </template>
      </e-collapse>
      <e-collapse title="边框" :expand="false">
        <t-form-item label="显示边框">
          <t-switch
            v-model="attribute.border.show"
            size="small"
            :label="['开', '关']"
          />
        </t-form-item>
        <template v-if="attribute.border.show">
          <t-form-item label="边框宽度">
            <t-input-number
              size="small"
              v-model="attribute.border.width"
              :min="0"
              :max="9999"
              :decimal-places="0"
            />
          </t-form-item>
          <t-form-item label="边框颜色">
            <t-color-picker
              size="small"
              :colorModes="['monochrome']"
              format="RGBA"
              enableAlpha
              v-model="attribute.border.color"
            />
          </t-form-item>
          <t-form-item label="边框圆角">
            <t-input-number
              size="small"
              v-model="attribute.border.radius"
              :min="0"
              :max="9999"
              :decimal-places="0"
            />
          </t-form-item>
          <t-form-item label="线条类型">
            <t-select size="small" v-model="attribute.border.lineType">
              <t-option
                v-for="item in lineTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </t-select>
          </t-form-item>
        </template>
      </e-collapse>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck" />
  </div>
</template>

<script>
import { fileUrl } from "/env";
import Gallery from "@/components/designer/gallery";
import CptData from "@/components/element/options/comp/cpt-data";
export default {
  name: "cpt-quota-progress-option",
  props: { attribute: Object, cptDataForm: Object, currentCpt: Object },
  components: { Gallery, CptData },
  computed: {
    textFamilyList() {
      return require("@/assets/font/font-list");
    },
    lineTypeList() {
      return require("@/assets/data/line-type");
    },
  },
  data() {
    return {
      fileUrl,
    };
  },
  methods: {
    showGallery() {
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl) {
      this.attribute.icon.url = fileUrl;
    },
  },
};
</script>

<style scoped></style>
